<page-heading [title]="'agents.trendgpt.pageTitle' | translate"
  [description]="'agents.trendgpt.pageDescription' | translate" />

<ul class="nav nav-tabs nav-bordered flex-grow-1 mb-0" role="tablist">
  <li class="nav-item" role="presentation">
    <a class="nav-link active" id="dash-tab" data-bs-toggle="tab" data-bs-target="#dash" type="button" role="tab"
      aria-controls="dash" aria-selected="true">
      <i class="mdi mdi-view-dashboard"></i>
      <span class="d-none d-md-inline ms-2">{{ 'agents.trendgpt.dashboardTab' | translate }}</span>
    </a>
  </li>
  <li class="nav-item" role="presentation">
    <a class="nav-link" id="agent-list-tab" data-bs-toggle="tab" data-bs-target="#agent-list" type="button" role="tab"
      aria-controls="agent-list" aria-selected="false">
      <i class="mdi mdi-format-list-bulleted"></i>
      <span class="d-none d-md-inline ms-2">{{ 'agents.trendgpt.agentListTab' | translate }}</span>
    </a>
  </li>
</ul>

<div class="tab-content" id="tabComponentsContent">
  <div class="tab-pane fade show active" id="dash" role="tabpanel" aria-labelledby="dash-tab">
    <!-- The wallet UI lives in /credits now; this is a read-only pointer. -->
    <div class="alert alert-info d-flex align-items-center justify-content-between mt-3">
      <div>
        <i class="mdi mdi-wallet me-2"></i>
        {{ 'agents.trendgpt.aiBalanceInfo' | translate }}
        <strong class="ms-1">{{ aiBalance | number }}</strong>
      </div>
      <a class="btn btn-info btn-sm" [routerLink]="['/wallet', 'AI']">
        {{ 'agents.trendgpt.manageCredits' | translate }}
      </a>
    </div>


    <div class="row mt-3">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div>
              <h5 class="header-title mb-3">{{ 'agents.trendgpt.creditUsageByAssistant' | translate }}</h5>

              <div class="d-flex flex-column mt-3 gap-2">
                @for (assistant of creditsSpent(); track $index) {
                <div>
                  <div class="d-flex align-items-center justify-content-between">
                    <span class="text-black font-16 fw-semibold">
                      {{ assistant.name }}
                    </span>

                    <span class="text-muted fs-14 fw-semibold">
                      {{ assistant['total'] }} {{ 'agents.trendgpt.creditsLabel' | translate }} ({{
                      (assistant['total'] / (sumAmount || 1)) * 100
                      | number : "1.1-1"
                      }}%)
                    </span>
                  </div>

                  <div class="progress mb-2" style="height: 14px;">
                    <div class="progress-bar" role="progressbar"
                      [style.width.%]="(assistant['total'] / (sumAmount || 1)) * 100" aria-valuemin="0" aria-valuemax="100">
                    </div>
                  </div>
                </div>
                } @if (assistants?.length === 0) {
                <div class="text-muted text-center mt-3">
                  {{ 'agents.trendgpt.noAssistantFound' | translate }}
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      
      <div class="col-6">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="header-title mb-3">{{ 'agents.trendgpt.dailyUsage' | translate }}</h5>
            @for(dayData of last7DaysData; track $index) {
            <div class="d-flex align-items-center justify-content-between p-2 bg-info-subtle rounded mt-3">
              <span class="text-black font-16 fw-semibold">{{ dayData.date }}</span>
              <span class="text-muted fs-14 fw-semibold">{{ dayData.credits }} {{ 'agents.trendgpt.creditsLabel' | translate }}</span>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="tab-pane fade show" id="agent-list" role="tabpanel" aria-labelledby="agent-list-tab">
    <div class="row mt-3 d-flex align-items-center justify-content-end">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2 btn-group trend-button">
        <button type="button" class="btn btn-success fw-bold" (click)="create()">
          + {{ 'agents.trendgpt.createAgent' | translate }}
        </button>
      </div>
    </div>

    <div class="row g-3 mb-0">
      <div class="col-12">
        <div class="row">
          <div class="col-12 mt-3">
            @for(assistant of assistants; track $index) {
            <div class="card cursor-pointer" (click)="edit(assistant)">
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 me-3">
                    <div class="avatar-sm">
                      <span class="avatar-title bg-primary-lighten text-primary rounded">
                        {{ assistant.name.slice(0, 2).toUpperCase() }}
                      </span>
                    </div>
                  </div>
                  <div class="flex-grow-1">
                    <h5 class="mt-0">
                      {{ assistant.name }}
                      <p class="badge mb-0 font-12" [ngClass]="{
                          'bg-success': assistant['status'] === 'ACTIVE',
                          'bg-danger': assistant['status'] === 'DISABLED'
                        }">
                        {{ assistant['status'] === 'ACTIVE' ? ('agents.trendgpt.statusActive' | translate) : ('agents.trendgpt.statusInactive' | translate) }}
                      </p>
                    </h5>
                    <p class="mb-0">
                      {{
                      assistant.jobDescription
                      ? (assistant.jobDescription.length > 100
                      ? (assistant.jobDescription | slice:0:100) + '...'
                      : assistant.jobDescription)
                      : '-'
                      }}
                    </p>
                  </div>
                  <div class="dropdown float-end">
                    <a href="#" class="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown"
                      aria-expanded="false" (click)="$event.stopPropagation()">
                      <i class="mdi mdi-dots-vertical"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end">
                      <a href="javascript:void(0);" class="dropdown-item"
                        (click)="edit(assistant); $event.stopPropagation()">
                        {{ 'agents.trendgpt.viewDetails' | translate }}
                      </a>
                      <a href="javascript:void(0);" class="dropdown-item"
                        (click)="$event.stopPropagation(); activeOrInactiveAgent(assistant.id);">
                        {{ assistant['status'] === 'ACTIVE' ? ('agents.trendgpt.deactivate' | translate) : ('agents.trendgpt.activate' | translate) }}
                      </a>
                      <a href="javascript:void(0);" class="dropdown-item text-danger"
                        (click)="delete(assistant); $event.stopPropagation()">
                        {{ 'agents.trendgpt.delete' | translate }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>